var _defs, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 149.999998",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1bc7e99efc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1 0.277344 L 149 0.277344 L 149 135.277344 L 1 135.277344 Z M 1 0.277344 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1bc7e99efc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009cff",
    d: "M 123.398438 135.246094 L 26.613281 135.246094 C 17.425781 135.246094 9.195312 130.484375 4.601562 122.511719 C 0.0078125 114.535156 0.0078125 105.015625 4.601562 97.039062 L 52.992188 13.046875 L 58.113281 16.011719 L 52.992188 13.046875 C 57.585938 5.074219 65.816406 0.308594 75.007812 0.308594 C 84.195312 0.308594 92.425781 5.070312 97.019531 13.046875 L 145.414062 97.039062 C 150.007812 105.015625 150.007812 114.535156 145.414062 122.511719 C 140.820312 130.484375 132.589844 135.246094 123.398438 135.246094 Z M 75.007812 12.164062 C 70.09375 12.164062 65.695312 14.710938 63.238281 18.972656 L 14.84375 102.96875 C 12.386719 107.230469 12.386719 112.320312 14.84375 116.585938 C 17.300781 120.847656 21.699219 123.394531 26.613281 123.394531 L 123.398438 123.394531 C 128.3125 123.394531 132.710938 120.847656 135.167969 116.585938 C 137.625 112.320312 137.625 107.230469 135.167969 102.96875 L 86.777344 18.972656 C 84.320312 14.710938 79.917969 12.164062 75.007812 12.164062 Z M 75.007812 12.164062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009cff",
    d: "M 75.007812 110.539062 C 70.476562 110.539062 66.792969 106.847656 66.792969 102.308594 C 66.792969 97.769531 70.476562 94.078125 75.007812 94.078125 C 79.535156 94.078125 83.21875 97.769531 83.21875 102.308594 C 83.21875 106.847656 79.535156 110.539062 75.007812 110.539062 Z M 75.007812 110.539062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009cff",
    d: "M 74.863281 85.972656 C 71.324219 85.972656 68.355469 83.316406 67.957031 79.792969 L 64.683594 50.949219 C 64.355469 48.046875 65.28125 45.132812 67.21875 42.957031 C 69.160156 40.777344 71.945312 39.527344 74.859375 39.527344 C 77.773438 39.527344 80.558594 40.777344 82.5 42.957031 C 84.441406 45.136719 85.367188 48.046875 85.035156 50.949219 L 81.765625 79.792969 C 81.363281 83.316406 78.398438 85.972656 74.859375 85.972656 Z M 79.710938 78.457031 Z M 79.710938 78.457031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerIcon);
export default __webpack_public_path__ + "static/media/danger-icon.c25fc2a6c65ccb3b7969f8dac038b679.svg";
export { ForwardRef as ReactComponent };